const password_rejected = {
    too_short: 'Lungimea minimă este {{min}}.',
    too_long: 'Lungimea maximă este {{max}}.',
    character_types: 'Sunt necesare cel puțin {{min}} tipuri de caractere.',
    unsupported_characters: 'Caracter neacceptat găsit.',
    pwned: 'Evitați utilizarea parolelor simple care sunt ușor de ghicit.',
    restricted_found: 'Evitați utilizarea excesivă a {{list, list}}.',
    restricted: {
        repetition: 'caractere repetate',
        sequence: 'caractere secvențiale',
        user_info: 'informațiile tale personale',
        words: 'contextul produsului',
    },
};
export default Object.freeze(password_rejected);
